<template>
  <section class="labs-advantage">
    <div class="labs-advantage__content container">
      <div class="labs-advantage__circle"></div>
      <div class="labs-advantage__text">
        <h3 class="labs-advantage__subtitle">THE ITEM 9 LABS CORP. ADVANTAGE</h3>
        <h1 class="labs-advantage__title">
          A vertically-integrated solution that our investors participate in.
        </h1>
      </div>
      <div class="labs-advantage__about-cards --fade-in-down" data-ivp-class="--animate">
        <div class="labs-advantage__single-card">
          <img  class="img-bg" src="../assets/labs-advantage/cardbg-1.jpeg">
          <div class="labs-advantage__color-overlay"></div>
          <div class="labs-advantage__card-content">
              <h1>Master Cultivation</h1>
              <p>
                Driven by experience operating successful cultivations
                across the United States and Canada, we take a plant-centric
                and responsible approach to growing high-quality flower.
              </p>
            </div>
          <div class="labs-advantage__overlay">
            <div class="labs-advantage__overlay-content">
              <div class="labs-advantage__icon-container">
                <img src="../assets/labs-advantage/plant.svg">
              </div>
              <h2>Master Cultivation</h2>
            </div>
          </div>
        </div>
        <div class="labs-advantage__single-card">
          <img class="img-bg" src="../assets/labs-advantage/cardbg-2.jpeg">
          <div class="labs-advantage__color-overlay"></div>
          <div class="labs-advantage__card-content">
              <h1>Innovative Extraction</h1>
              <p>
                Our extraction team combines time-honored processes with
                cutting-edge techniques to formulate high-quality products
                across a variety of form factors.
              </p>
            </div>
          <div class="labs-advantage__overlay">
            <div class="labs-advantage__overlay-content">
              <div class="labs-advantage__icon-container">
                <img src="../assets/labs-advantage/chart.svg">
              </div>
              <h2>Innovative Extraction</h2>
            </div>
          </div>
        </div>
        <div class="labs-advantage__single-card">
          <img class="img-bg" src="../assets/labs-advantage/cardbg-3.jpeg">
          <div class="labs-advantage__color-overlay"></div>
          <div class="labs-advantage__card-content">
              <h1>Award-Winning Products</h1>
              <p>
                Item 9 Labs has earned 24 podium awards in product competitions
                since inception, including 1st place finishes across the Cannabis
                Cup, 710 Degree Cup and ERRL Cup.
              </p>
            </div>
          <div class="labs-advantage__overlay">
            <div class="labs-advantage__overlay-content">
              <div class="labs-advantage__icon-container">
                <img src="../assets/labs-advantage/award.svg">
              </div>
              <h2>Award-Winning Products</h2>
            </div>
          </div>
        </div>
        <div class="labs-advantage__single-card">
          <img  class="img-bg" src="../assets/labs-advantage/cardbg-4.jpeg">
          <div class="labs-advantage__color-overlay"></div>
          <div class="labs-advantage__card-content">
              <h1>Modern Retail</h1>
              <p>
                Our powerhouse of knowledge and time-tested SOPs guide franchise
                partners through every operational function of the business.
              </p>
            </div>
          <div class="labs-advantage__overlay">
            <div class="labs-advantage__overlay-content">
              <div class="labs-advantage__icon-container">
                <img src="../assets/labs-advantage/retail.svg">
              </div>
              <h2>Modern Retail</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "LabsAdvantage",
  data() {
    return {};
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../styles/components/LabsAdvantage.scss";
</style>
